module.exports = __webpack_public_path__ + "img/3c9d15e.png";